import { useData } from './useData';

export enum PolicyPages {
    returns = 'refunds',
    termsAndConditions = 'terms-and-conditions',
    privacyPolicy = 'privacy-policy',
}

export const useSettings = () => {
    const { allSettings } = useData();

    return {
        getPage: (key: string) => {
            if (!allSettings?.data) return null;
            
            // @ts-ignore
            return allSettings?.data[`page.${key.replaceAll('-', '_')}` as PolicyPages] || null;
        },
    };
};
